import { mutate } from 'swr';
import { getCacheKey } from 'utils/getCacheKey';

export const mutateSkills = () => {
  const searchedKey = getCacheKey('/skill_names');
  if (searchedKey) {
    mutate(searchedKey);
  }
};
